import type { LucideIcon } from "lucide-react";
import { Link } from "react-router";
import { Card, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

// Ported from connect-v2's dashboard MetricCard; next/link replaced by React Router.
export function StatCard({
	label,
	value,
	sub,
	icon: Icon,
	loading,
	href,
	valueClassName,
}: {
	label: string;
	value: string;
	sub?: string;
	icon: LucideIcon;
	loading?: boolean;
	href?: string;
	valueClassName?: string;
}) {
	if (loading) {
		return (
			<Card className="min-w-0 overflow-hidden py-4">
				<CardHeader className="px-4">
					<Skeleton className="h-4 w-24" />
					<Skeleton className="mt-2 h-7 w-20" />
					<Skeleton className="mt-1 h-3 w-32" />
				</CardHeader>
			</Card>
		);
	}

	const card = (
		<Card
			className={cn(
				"from-primary/5 to-card min-w-0 overflow-hidden bg-linear-to-t py-4 shadow-xs",
				href && "hover:border-primary/40 transition-colors",
			)}
		>
			<CardHeader className="px-4">
				<p className="text-muted-foreground flex min-w-0 items-center gap-1.5 text-xs sm:text-sm">
					<Icon className="size-3.5 shrink-0" />
					<span className="truncate">{label}</span>
				</p>
				<p
					className={cn(
						"mt-1 text-xl leading-tight font-semibold tabular-nums sm:text-2xl",
						valueClassName,
					)}
				>
					{value}
				</p>
				{sub && <p className="text-muted-foreground mt-0.5 text-xs leading-snug">{sub}</p>}
			</CardHeader>
		</Card>
	);

	return href ? (
		<Link to={href} className="block min-w-0 rounded-xl">
			{card}
		</Link>
	) : (
		card
	);
}
